import React from 'react'
import { Link } from 'react-router-dom'
import { SmallText, Div } from 'konsys-ui'
import logo from '../images/login/logo.png'
import Header from '../components/menu/header'

const version = '6.1.9'

export default {
  navTheme: 'light',
  primaryColor: '#D95948',
  layout: 'sidemenu',
  contentWidth: 'Fluid',
  fixedHeader: false,
  autoHideHeader: false,
  fixSiderbar: false,
  colorWeak: false,
  menu: {
    locale: true,
  },
  rightContentRender: () => <Header />,
  title: 'Padoongrich ERP',
  pwa: false,
  iconfontUrl: '',
  logo,
  footerRender: () => <Div margin='0 auto 24px auto'><SmallText color='#999'>{`v. ${version}`}</SmallText></Div>,
  menuItemRender: (menuItemProps, defaultDom) => {
    if (menuItemProps.isUrl) {
      return defaultDom
    }

    return <Link to={menuItemProps.path}>{defaultDom}</Link>
  },
}

export const menuItems = [
  {
    id: 'home',
    path: '/home', // link
    name: 'หน้าแรก',
    icon: 'home',
  }, {
    id: 'JOB',
    path: '/job', // link
    name: 'สัญญางาน',
    icon: 'folder-open',
  }, {
    id: 'SHIPPING_ORDER',
    path: '/shipping-order', // link
    name: 'ใบสั่งบรรทุก',
    icon: 'profile',
  }, {
    id: 'FUEL',
    path: '/fill-order', // link
    name: 'ใบเบิกน้ำมัน',
    icon: 'thunderbolt',
  }, {
    id: 'RECOMMEND_FUEL',
    path: '/recommend-fuel', // link
    name: 'ตั้งค่าน้ำมัน',
    icon: 'exception',
  }, {
    id: 'INVOICE',
    path: '/invoice', // link
    name: 'ใบวางบิล / ใบแจ้งหนี้',
    icon: 'file-text',
  }, {
    id: 'BILL',
    path: '/bill', // link
    name: 'ใบปะหน้า',
    icon: 'file-done',
  }, {
    id: '#',
    path: '/#', // link
    name: 'สมุดรายชื่อ',
    icon: 'contacts',
    children: [
      {
        id: 'CLIENT',
        path: '/client',
        name: 'ผู้จ้าง',
        icon: 'team',
      }, {
        id: 'SUPPLIER',
        path: '/supplier', // link
        name: 'ผู้จำหน่าย',
        icon: 'user',
      }, {
        id: 'STARTPOINT',
        path: '/start-point',
        name: 'ต้นทาง',
        icon: 'to-top',
      }, {
        id: 'DESTINATION',
        path: '/destination',
        name: 'ปลายทาง',
        icon: 'environment',
      },
    ],
  },
  // {
  //   id: 'DESTINATION',
  //   path/: 'destination', // link
  //   name: 'จุดรับส่ง',
  //   icon: 'far fa-map-marked',
  // },
  {
    id: 'GAS_STATION',
    path: '/gas-station', // link
    name: 'ปั๊มน้ำมัน',
    icon: 'shop',
  }, {
    id: '#',
    path: '/##', // link
    name: 'ช่าง',
    icon: 'tool',
    children: [
      {
        id: 'MECHANIC',
        path: '/mechanic', // link
        name: 'ช่าง',
        icon: 'user',
      }, {
        id: 'GARAGE',
        path: '/garage', // link
        name: 'ศูนย์บริการ',
        icon: 'shop',
      }, {
        id: 'TIREPATCHSTORE',
        path: '/tire-patch-shop', // link
        name: 'ร้านปะยาง',
        icon: 'shop',
      },
    ],
  }, {
    id: '#',
    path: '/###', // link
    name: 'รถบรรทุก',
    icon: 'car',
    children: [
      {
        id: 'TRUCK_OWNER',
        path: '/truckowner', // link
        name: 'เจ้าของรถบรรทุก',
        icon: 'user',
      }, {
        id: 'TRUCK',
        path: '/truck', // link
        name: 'รถบรรทุก',
        icon: 'car',
      },
      {
        id: 'TRUCK',
        path: '/trailer', // link
        name: 'หางพ่วง',
        icon: 'car',
      },
    ],
  }, {
    id: 'DRIVER',
    path: '/driver', // link
    name: 'พนักงานขับรถ',
    icon: 'idcard',
  }, {
    id: 'DRIVER_COMPENSATION',
    path: '/driver-compensation', // link
    name: 'เบี้ยเลี้ยง',
    icon: 'dollar',
  }, {
    id: 'GASSTATION_REPORT',
    path: '/gasstation-report', // link
    name: 'รายงานการเติมน้ำมัน',
    icon: 'exception',
  }, {
    id: 'REPAIR',
    path: '/repair-job', // link
    name: 'ใบแจ้งซ่อม',
    icon: 'exception',
  }, {
    id: 'TIREPATCHLOG',
    path: '/tire-patch', // link
    name: 'ปะยาง',
    icon: 'exception',
  }, {
    id: '#',
    path: '/####', // link
    name: 'สต๊อกสินค้า',
    icon: 'shop',
    children: [
      {
        id: 'TIRE',
        path: '/tire-inventory', // link
        name: 'สต๊อกยาง',
        icon: 'shop',
      }, {
        id: 'INVENTORY',
        path: '/inventory', // link
        name: 'สต๊อกสินค้าทั่วไป',
        icon: 'shop',
      },
    ],
  }, {
    id: 'PURCHASEREQUEST',
    path: '/purchase-requisition', // link
    name: 'ใบขอเสนอซื้อ',
    icon: 'exception',
  }, {
    id: 'PURCHASEORDER',
    path: '/purchase-order', // link
    name: 'ใบสั่งซื้อ',
    icon: 'exception',
  }, {
    id: '#',
    path: '/#######', // link
    name: 'ใบรับสินค้า',
    icon: 'exception',
    children: [
      {
        id: 'GOODRECEIVETIRE',
        path: '/tire-good-received', // link
        name: 'ใบรับสินค้ายาง',
        icon: 'exception',
      }, {
        id: 'GOODRECEIVE',
        path: '/good-received', // link
        name: 'ใบรับสินค้าทั่วไป',
        icon: 'exception',
      },
    ],
  }, {
  }, {
    id: 'WAREHOUSE',
    path: '/warehouse', // link
    name: 'คลังสินค้า',
    icon: 'shop',
  }, {
    id: '#',
    path: '/#####',
    name: 'จัดการผู้ใช้',
    icon: 'solution',
    children: [
      {
        id: 'USER',
        path: '/user',
        name: 'ผู้ใช้',
        icon: 'user',
      }, {
        id: 'ROLE',
        path: '/role',
        name: 'หน้าที่',
        icon: 'lock',
      },
    ],
  },
  // {
  //   id: 'LOGS',
  //   path: '/report', // link
  //   name: 'รายงาน',
  //   icon: 'file-exclamation',
  // },
  {
    id: '#',
    path: '/######',
    name: 'รายงาน',
    icon: 'file-exclamation',
    children: [
      {
        id: 'DASHBOARD',
        path: '/dashboard',
        name: 'Dashboard',
        icon: 'fund',
      }, {
        id: 'LOGS',
        path: '/report',
        name: 'รายงาน',
        icon: 'database',
      }, {
        id: 'EXPENSE',
        path: '/expense',
        name: 'ค่าใช้จ่าย',
        icon: 'tag',
      }, {
        id: 'FUELCOSTSUMMARY',
        path: '/fuel-cost-summary',
        name: 'ตรวจบิลน้ำมัน',
        icon: 'audit',
      },
    ],
  },
]
